import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { ParentCard } from '@/entities/parent'
import { useStudentParentItem } from '@/shared/api/parent'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/users/parents/$parentId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()
  const { parentId } = Route.useParams()

  const { data: parent, isLoading, isError } = useStudentParentItem({ id: parentId })

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка родителя')}>
      <ParentCard parent={parent?.studentParent} isLoading={isLoading} isError={isError} />
    </Offcanvas>
  )
}
